import { render, staticRenderFns } from "./AddEditCsr.vue?vue&type=template&id=1f7f22dc&"
import script from "./AddEditCsr.vue?vue&type=script&lang=js&"
export * from "./AddEditCsr.vue?vue&type=script&lang=js&"
import style0 from "./AddEditCsr.vue?vue&type=style&index=0&id=1f7f22dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports